import type { ForecastRow } from '../../executiveintel/framework';

type Props = { forecasts?: ForecastRow[] };

export function ForecastEnginePanel({ forecasts = [] }: Props) {
  return (
    <div className="grid gap-3 grid-cols-2 sm:grid-cols-4">
      {forecasts.map((f) => (
        <div key={f.metric} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-xs text-slate-500">{f.metric}</p>
          <p className="text-sm text-slate-600 dark:text-slate-400">{f.current}</p>
          <p className="text-lg font-semibold">→ {f.forecast}</p>
          <div className="mt-2 h-1.5 rounded-full bg-slate-100 dark:bg-slate-800">
            <div className="h-1.5 rounded-full bg-brand-500" style={{ width: `${f.confidence}%` }} />
          </div>
          <p className="mt-0.5 text-xs text-slate-500">{f.confidence}% confidence</p>
        </div>
      ))}
    </div>
  );
}
